import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from "gsap";

class Modality extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        this.buttonClose = this.element.querySelector(".button-back");

        this.body = document.querySelector("body");
    }

    attach() {
        if (this.buttonClose)
            this.buttonClose.addEventListener("click", this.close);
    }

    detach() {
        if (this.buttonClose)
            this.buttonClose.removeEventListener("click", this.close);
    }

    open = () => {
        const t = gsap.timeline();

        this.element.style.display = "block";
        t.fromTo(
            this.element,
            { alpha: 0 },
            { alpha: 1, duration: 0.5, ease: "none" },
            0
        );
        t.fromTo(
            this.element,
            { scale: 0.7 },
            { scale: 1, duration: 1, ease: "expo.out" },
            0
        );

        return t;
    };
    close = () => {
        const t = gsap.timeline();
        this.body.classList.remove("modality-open");
        if (this.cartPage) this.cartPage.classList.remove("modality-open");

        t.to(this.element, { alpha: 0, duration: 0.5 }, 0);
        t.add(() => (this.element.style.display = "none"));
        return t;
    };
}

export { Modality };
